import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade, Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";

// Your images
import slider1 from "../../assets/img/slider/slider-1.jpg";
import slider2 from "../../assets/img/slider/slider-2.jpg";
import slider3 from "../../assets/img/slider/slider-3.jpg";

const Slider = () => {
  const slides = [
    {
      id: 1,
      image: slider1,
      title: "Book <span>Cab</span> For Your Ride",
      description:
        "Experience comfortable and reliable cab services for your daily commute, business trips, and special occasions. Book your ride anytime, anywhere with our easy-to-use platform.",
    },
    {
      id: 2,
      image: slider2,
      title: "Ride <span>Keke & Okada</span> Today",
      description:
        "Beat the traffic with our affordable Keke and fast Okada services. Perfect for short distances, quick errands, and navigating through busy city streets efficiently.",
    },
    {
      id: 3,
      image: slider3,
      title: "Fast <span>Logistics</span> Service",
      description:
        "Reliable delivery and logistics solutions for packages, goods, and documents. We ensure safe and timely delivery to your desired destination with real-time tracking.",
    },
  ];

  return (
    <>
      {/* All styles inside the component */}
      <style jsx>{`
        .hero-section {
          position: relative;
          width: 100%;
          height: 100vh;
          overflow: hidden;
        }

        .hero-single {
          width: 100%;
          height: 100vh;
          background-size: cover;
          background-position: center;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .hero-single::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.8); /* 30% dark overlay */
          z-index: 1;
        }

        .hero-content {
          position: relative;
          z-index: 2;
          color: white;
          text-align: center;
          max-width: 900px;
          padding: 0 20px;
        }

        .hero-sub-title {
          font-size: 22px;
          font-weight: 600;
          letter-spacing: 3px;
          text-transform: uppercase;
          margin-bottom: 15px;
          opacity: 0.9;
        }

        .hero-title {
          font-size: 68px;
          font-weight: 800;
          line-height: 1.1;
          margin-bottom: 20px;
        }

        .hero-title span {
          color: #fede33; /* Changed from #4eac3d to #fede33 (yellow) */
        }

        .hero-content p {
          font-size: 18px;
          line-height: 1.8;
          margin-bottom: 35px;
          opacity: 0.95;
        }

        .hero-btn {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap: wrap;
          gap: 15px;
          margin-top: 35px;
        }

        .hero-btn a {
          display: inline-block;
          padding: 15px 35px;
          border-radius: 50px;
          font-weight: 600;
          text-transform: uppercase;
          font-size: 15px;
          transition: all 0.4s;
          text-decoration: none;
        }

        /* About More Button */
        .theme-btn {
          background: #098535; /* Changed to green #098535 */
          color: white;
          border: 2px solid #098535;
        }

        .theme-btn:hover {
          background: #000000; /* Hover remains black */
          color: white;
          border-color: #000000;
          transform: translateY(-4px);
        }

        /* Learn More Button */
        .theme-btn2 {
          background: transparent;
          color: white;
          border: 2px solid white;
        }

        .theme-btn2:hover {
          background: #fede33; /* Hover yellow #fede33 */
          color: #222;
          border-color: #fede33;
        }

        /* Navigation Arrows */
        .hero-slider-prev,
        .hero-slider-next {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 60px;
          height: 60px;
          background: rgba(255, 255, 255, 0.15);
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 28px;
          cursor: pointer;
          z-index: 10;
          backdrop-filter: blur(10px);
          border: 2px solid rgba(255, 255, 255, 0.2);
          transition: all 0.4s;
        }

        .hero-slider-prev:hover,
        .hero-slider-next:hover {
          background: #fede33; /* Changed to yellow #fede33 */
          border-color: #fede33;
          color: #222;
          transform: translateY(-50%) scale(1.1);
        }

        .hero-slider-prev {
          left: 40px;
        }
        .hero-slider-next {
          right: 40px;
        }

        /* Vertical Dots Navigation on the Right */
        .hero-vertical-pagination {
          position: absolute;
          right: 40px;
          top: 50%;
          transform: translateY(-50%);
          z-index: 10;
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .hero-vertical-pagination .swiper-pagination-bullet {
          width: 14px;
          height: 14px;
          background: rgba(255, 255, 255, 0.4);
          border-radius: 50%;
          opacity: 1;
          transition: all 0.4s;
          cursor: pointer;
          position: relative;
        }

        .hero-vertical-pagination .swiper-pagination-bullet::after {
          content: "";
          position: absolute;
          top: 50%;
          left: 50%;
          width: 8px;
          height: 8px;
          background: white;
          border-radius: 50%;
          transform: translate(-50%, -50%) scale(0);
          transition: all 0.4s;
        }

        .hero-vertical-pagination .swiper-pagination-bullet-active {
          background: #fede33; /* Changed to yellow #fede33 */
          transform: scale(1.3);
        }

        .hero-vertical-pagination .swiper-pagination-bullet-active::after {
          transform: translate(-50%, -50%) scale(1);
        }

        /* Responsive */
        @media (max-width: 1200px) {
          .hero-title {
            font-size: 56px;
          }
        }
        @media (max-width: 992px) {
          .hero-title {
            font-size: 48px;
          }
          .hero-slider-prev,
          .hero-slider-next {
            width: 50px;
            height: 50px;
            font-size: 22px;
          }
          .hero-slider-prev {
            left: 20px;
          }
          .hero-slider-next {
            right: 20px;
          }
        }
        @media (max-width: 768px) {
          .hero-title {
            font-size: 38px;
          }
          .hero-sub-title {
            font-size: 18px;
          }
          .hero-content p {
            font-size: 16px;
          }
          .hero-btn a {
            padding: 12px 25px;
            font-size: 14px;
          }
          .hero-vertical-pagination {
            display: none;
          } /* Hide vertical dots on mobile */
        }
      `}</style>

      <div className="hero-section">
        <Swiper
          modules={[Autoplay, EffectFade, Navigation, Pagination]}
          spaceBetween={0}
          slidesPerView={1}
          loop={true}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          effect="fade"
          fadeEffect={{ crossFade: true }}
          speed={1200}
          navigation={{
            prevEl: ".hero-slider-prev",
            nextEl: ".hero-slider-next",
          }}
          pagination={{
            clickable: true,
            el: ".hero-vertical-pagination",
            bulletClass: "swiper-pagination-bullet",
            bulletActiveClass: "swiper-pagination-bullet-active",
          }}
        >
          {slides.map((slide) => (
            <SwiperSlide key={slide.id}>
              <div
                className="hero-single"
                style={{ backgroundImage: `url(${slide.image})` }}
              >
                <div className="hero-content">
                  <h6 className="hero-sub-title">Welcome To CabandGo!</h6>
                  <h1
                    className="hero-title"
                    dangerouslySetInnerHTML={{ __html: slide.title }}
                  />
                  <p>{slide.description}</p>
                  <div
                    className="hero-btn"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {/* <a href="#" className="theme-btn">
                      About More <i className="fas fa-arrow-right"></i>
                    </a> */}
                    <a href="#" className="theme-btn2">
                      Learn More <i className="fas fa-arrow-right"></i>
                    </a>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}

          {/* Left Arrow */}
          <div className="hero-slider-prev">
            <i className="fas fa-angle-left"></i>
          </div>

          {/* Right Arrow */}
          <div className="hero-slider-next">
            <i className="fas fa-angle-right"></i>
          </div>

          {/* Vertical Dots Navigation (Right Side) */}
          <div className="hero-vertical-pagination"></div>
        </Swiper>
      </div>
    </>
  );
};

export default Slider;
